import React from 'react'
import { Clock, ListChecks, Lock, Shield, MonitorSmartphone } from 'lucide-react'

export default function () {
	const beneficios = [
		{
			icon: <Shield size={40} color="#c32232" />,
			title: "Proteção Total",
			description: "Seus dados são protegidos com criptografia de ponta a ponta e seguem todas as normas da LGPD."
		},
		{
			icon: <Clock size={40} color="#c32232" />,
			title: "Disponível 24h",
			description: "Acesse suas informações médicas a qualquer hora, em qualquer lugar."
		},
		{
			icon: <Lock size={40} color="#c32232" />,
			title: "Sigilo Absoluto",
			description: "Apenas profissionais de saúde autorizados por você podem acessar suas informações."
		},
		{
			icon: <ListChecks size={40} color="#c32232" />,
			title: "Informações Completas",
			description: "Alergias, medicamentos, contatos de emergência, exames, laudos e muito mais."
		},
		{
			icon: <MonitorSmartphone size={40} color="#c32232" />,
			title: "Sempre à Mão",
			description: "Acessível via smartphone, tablet ou computador. Interface simples e intuitiva."
		}
	];

	return (
		<section id="beneficios" className="pb-20 pt-28 px-4 bg-gray-200">
			<div className="container mx-auto">
				<div className="text-center mb-16">
					<h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
						Por que escolher a Positronic?
					</h2>
					<p className="text-lg text-gray-700 max-w-3xl mx-auto">
						Nosso sistema foi desenvolvido para garantir que suas informações médicas
						estejam sempre acessíveis para quem realmente importa.
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
					{beneficios.map((beneficio, index) => (
						<BeneficioCard
							key={index}
							icon={beneficio.icon}
							title={beneficio.title}
							description={beneficio.description}
						/>
					))}
				</div>
			</div>
		</section>
	)
}

function BeneficioCard({ icon, title, description }) {
	return (
		<div className="bg-white p-6 rounded-lg shadow-suave transition-all duration-300 hover:shadow-md gradient-card">
			<div className="text-accent mb-4 flex justify-center">{icon}</div>
			<h3 className="text-xl font-semibold text-gray-900 mb-2 text-center">{title}</h3>
			<p className="text-gray-700 text-center">{description}</p>
		</div>
	)
}

